import api from '../config/api';

export const search = (searchParams = '') => api.get(`/searcher/${searchParams}`);
